import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "114",
  height: "114",
  viewBox: "0 0 114 114",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g id=\"ic_cert\"><g id=\"Group 3902\"><g id=\"Group 3901\"><rect id=\"Rectangle 2812\" x=\"39.2295\" y=\"33.7714\" width=\"17.0483\" height=\"16.7543\" fill=\"#D7D8DB\"></rect><rect id=\"Rectangle 2813\" x=\"57.3438\" y=\"33.7714\" width=\"17.0483\" height=\"16.7543\" fill=\"#D7D8DB\"></rect></g><g id=\"Group 4048\"><path id=\"Vector 440\" d=\"M23 65.6204V35.3119C23 33.7883 24.1401 32.5045 25.6471 32.2802C29.1458 31.7594 35.3933 30.6689 39.9093 28.981C44.9161 27.1097 52.0512 22.9131 55.209 20.9931C56.1985 20.3915 57.4387 20.3915 58.4282 20.9931C61.586 22.9131 68.7211 27.1097 73.7279 28.981C78.2439 30.6689 84.4914 31.7594 87.99 32.2802C89.4971 32.5045 90.6372 33.7869 90.6372 35.3106V65.5703C90.6372 72.3081 79.113 92.5182 56.8186 92.5133C34.5402 92.5084 23 72.3459 23 65.6204Z\" fill=\"white\" stroke=\"#4D4E58\" stroke-width=\"4\"></path><path id=\"Vector 441\" d=\"M31.2002 64.2875V39.5522C31.2002 39.5522 39.0076 38.6591 44.0103 36.808C49.0129 34.9569 56.8203 30.0723 56.8203 30.0723L56.8203 84.4572C39.9428 84.4535 31.2002 69.3317 31.2002 64.2875Z\" fill=\"#E0E5FF\"></path><g id=\"Group 4047\"><ellipse id=\"Ellipse 385\" cx=\"57.2291\" cy=\"56.7238\" rx=\"14.3473\" ry=\"14.0998\" fill=\"white\" stroke=\"#4D4E58\" stroke-width=\"4\"></ellipse><path id=\"Vector 6\" d=\"M50.207 55.5921L55.0516 60.8519L63.25 51.8793\" stroke=\"#4D4E58\" stroke-width=\"3\"></path></g></g></g><g id=\"ic_warning\"><g id=\"Group 3257\"><g id=\"Group 3070\"><circle id=\"Ellipse 173\" cx=\"86.0003\" cy=\"85.9997\" r=\"16.6667\" transform=\"rotate(-180 86.0003 85.9997)\" fill=\"#7B90FF\"></circle></g></g><path id=\"Vector 6_2\" d=\"M77.667 84.1609L83.8575 91L94.3337 79.3333\" stroke=\"white\" stroke-width=\"4\"></path></g></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  name: 'ShieldCheck',
  props: {
    size: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
}

})